/**
 * Amana — global UI bundle
 * Cart count updater, FAQ accordion animation, mobile nav toggle.
 */
(function () {
  'use strict';

  /* FAQ accordion: native <details> toggle. Chevron rotation handled by CSS [open] selector. */

  /* ===== Language toggle (client-side, persisted in localStorage) ===== */
  var LANG_STORAGE_KEY = 'amana-lang';
  function getLang() {
    try { var v = localStorage.getItem(LANG_STORAGE_KEY); return (v === 'ar' || v === 'en') ? v : 'en'; }
    catch (e) { return 'en'; }
  }
  function applyLang(lang) {
    var html = document.documentElement;
    html.lang = lang;
    html.dir = (lang === 'ar') ? 'rtl' : 'ltr';
    html.classList.remove('lang-en', 'lang-ar');
    html.classList.add('lang-' + lang);
    document.querySelectorAll('[data-lang-label]').forEach(function (el) {
      el.textContent = lang.toUpperCase();
    });
    try { localStorage.setItem(LANG_STORAGE_KEY, lang); } catch (e) {}
  }
  // Sync the label with whatever the inline head script set
  applyLang(getLang());
  document.querySelectorAll('[data-lang-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      applyLang(getLang() === 'en' ? 'ar' : 'en');
    });
  });

  /* ===== Cart bubble — refresh on Cart API state changes ===== */
  function refreshCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.toggleAttribute('hidden', cart.item_count === 0);
        });
      })
      .catch(function () { /* silent */ });
  }
  document.addEventListener('cart:updated', refreshCartCount);
  refreshCartCount();

  /* ===== Mobile nav toggle ===== */
  var navToggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-nav-drawer]');
  if (navToggle && nav) {
    navToggle.addEventListener('click', function () {
      var open = nav.getAttribute('aria-hidden') !== 'true';
      nav.setAttribute('aria-hidden', open ? 'true' : 'false');
      document.body.classList.toggle('nav-open', !open);
    });
  }
})();
